import mixins from "../mixins";
export class CompanyInfo extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("CompanyInfo");
    this.state = {
      links:mixins.links||[],
      rowcount: 0,
      tableData: [],
      columns: mixins.columns,
      fields: mixins.fields([],['user_id','createdAt'])
    }
  }

  onPageChange() {

  }

  editAction() {

  }

  deleteAction() {

  }

  onSearch() {
    let data = this.refs.form.form.current.getData();
    return this.fetchData(data.user_name?{
      search_key:"user_name",
      search_value:data.user_name
    }:{});
  }

  addRecord(e,data) {
    this.api.execApi('postProfileCreate',{
      ...data,
      "user_role": "CLIENT",
    }).then(async (response)=>{
      await this.onSearch();
      this.refs.addedit.closebtn.click();
      success("Client added successfully");
      console.log({data,response});
    })
  }

  fetchData(data={}) {
    this.api.apiGetProfileAll(data).then((response) => {
      let result = response.data.items[0];
      this.setState({
        rowcount: result.total,
        tableData: result.data
      });
    });
  }

  componentDidMount() {
    this.fetchData();
  }

  render() {
    const breadCumRight = () => (
      <div className="col-auto float-end ml-auto">
        <a href="#" className="btn add-btn" data-bs-toggle="modal" data-bs-target="#appModal">
          <i className="fa fa-plus"></i> Add Client
        </a>
        {/* <div className="view-icons">
          <a className="grid-view btn btn-link" href="/app/employees/clients">
            <i className="fa fa-th"></i>
          </a>
          <a className="list-view btn btn-link active" href="/app/employees/clients/personal-info">
            <i className="fa fa-bars"></i>
          </a>
        </div> */}
      </div>
    );
    let { tableData, columns, rowcount,links,fields } = this.state;
    return <AppWrapper title="Clients" slots={{ breadCumRight }}>
      <AppLinkTabs data={links} ></AppLinkTabs>
      <AppForm className="row filter-row" ref="form">
        {columns.filter(o => o.hasFilter).map((o, i) => (
          <div className="col" key={o.name + '' + i} >
            <AppInputFocus
              type={o.type || 'text'}
              name={o.dataIndex}
              label={o.title}
              {...Object.only(o, ['className', 'options'])}
              className={o.className || ''}
            >
            </AppInputFocus>
          </div>
        ))}
        <div className="col">
          <button
            className="btn btn-warning btn-block w-100"
            onClick={() => this.onSearch()}
          >
            Search
          </button>
        </div>
      </AppForm>
      <div className="row mb-4">
        <div className="col">
          <AppTable
            data={tableData}
            columns={columns}
            reorder={true}
            onChange={(...arg) => this.onPageChange(...arg)}
            total={rowcount}
            editAction={(data) => this.editAction(data)}
            deleteAction={(data) => this.deleteAction(data)}
            pageSize={10}
          ></AppTable>
        </div>
      </div>
      <AppModalForm
        ref="addedit"
        title="Add Client"
        fields={fields}
        onSubmit={(...arg) => this.addRecord(...arg)}
        submitText="Add">
      </AppModalForm>
    </AppWrapper>;
  }
}

export default connect(CompanyInfo);